export default __webpack_public_path__ + "static/media/siva.2cc73725.jpg";